import { css } from "@emotion/react";
import { useHistory } from "react-router";

import { Heading, PromoBannerV2, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { SubscriptionRoutes } from "routes/subscription";
import { withVar } from "themes/helpers";

type UpgradeReportPageProps = {
  heading: string;
  description: string;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function UpgradeReportPage({ heading, description }: UpgradeReportPageProps) {
  const history = useHistory();

  return (
    <Flex column marginTop={withVar(SpacingToken.Spacing5)} alignItems="center">
      <PromoBannerV2
        css={css({ maxWidth: "800px", width: "100%" })}
        primaryButton={{ label: "Upgrade plan", handleClick: () => history.push(SubscriptionRoutes.UpgradeBusiness) }}
      >
        <Heading size="lg">{heading}</Heading>
        <Text>{description}</Text>
      </PromoBannerV2>
    </Flex>
  );
}
